const Account = {
  init: function () {
    Account.select();
    Account.events();
    Account.addresses();
    Account.register();
  },

  select: function () {

  },

  events: function () {
    // User type
    const initialPersonType = $('input[name="billing_person"]:checked');
    Account.handlePersonType(initialPersonType.val());
    $('input[name="billing_person"]').on("change", function () {
      var input = $(this);
      Account.handlePersonType(input.val());
    });

    let passwordFields = $("#change-password-fields");
    $('input[name="change-password"]').on("change", function () {
      passwordFields.toggleClass("hidden");
    });

    //Validation
    let form = $(".woocommerce-form-register");
    form.on("submit", function (e) {
      if (!helpers.validate(form)) {
        e.preventDefault();
      }
    });
  },

  handlePersonType(personType) {
    if (personType == "legal") {
      $(".person-legal").show();
      $(".person-legal").children("input").removeClass("disabled");
    } else {
      $(".person-legal").hide();
      $(".person-legal").children("input").addClass("disabled");
    }
  },

  addresses: function () {
    var form = $(".edit-address");
    form.find('input[name="person"]').on("change", function () {
      var input = $(this);
      if (input.attr("id") == "legal-person") {
        form.find(".legal").slideDown();
      } else {
        form.find(".legal").slideUp();
      }
    });
  },

  register: function () {
    var register_form = $(".register");
    register_form
      .find('input[name="reg_person-type"]')
      .on("change", function () {
        var input = $(this);
        if (input.attr("id") == "reg_legal-person") {
          register_form.find(".legal").show();
        } else {
          register_form.find(".legal").hide();
        }
      });
  },
};

export default Account;
